import styled from 'styled-components'

export const PageWrapper = styled.div`
  background: ${props => props.theme.colors.white};
  padding: 0 0 30px 0;

  table {
    th {
      padding-top: 31px;
      padding-bottom: 10px;
    }

    th:first-child,
    td:first-child {
      padding-left: 50px;
    }

    th:last-child,
    td:last-child {
      padding-right: 65px;
    }

    .actions-cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .datepicker-wrapper {
    div:first-child {
      margin-right: 30px;
    }
  }
`
